import classNames from "classnames";

import MultimediaWithFlag from "@stadium/shared/src/components/shared/multimedia";
import ResponsiveImage from "@stadium/shared/src/components/shared/responsive-image";

import styles from "./main.module.scss";

interface ImageWrapperProps {
  src?: string;
  srcMobile?: string;
  srcTablet?: string;
  noImageText: string;
  alt: string;
  imageWrapperClassName: string;
  imageClassName: string;
  showNoImageTextUppercase?: boolean;
}

const ImageWrapper = (props: ImageWrapperProps) => {
  const {
    src,
    srcMobile,
    srcTablet,
    noImageText,
    imageWrapperClassName,
    imageClassName,
    alt,
    showNoImageTextUppercase = true,
  } = props;
  const desktopSrc = src || srcTablet || srcMobile || "";
  const hasImage = Boolean(desktopSrc);
  const hasResponsiveSources = Boolean(srcMobile || srcTablet);

  const imageNode = hasResponsiveSources ? (
    <ResponsiveImage
      mobileSrc={srcMobile || desktopSrc}
      tabletSrc={srcTablet}
      desktopSrc={desktopSrc}
      alt={alt}
      className={imageClassName}
    />
  ) : (
    <MultimediaWithFlag src={desktopSrc} type="image" className={imageClassName} alt={alt} />
  );

  return (
    <div
      className={classNames(imageWrapperClassName, {
        [styles.cardImageDefault]: !hasImage,
      })}
    >
      {hasImage ? (
        imageNode
      ) : (
        <div
          className={classNames(styles.cardDefaultTitle, {
            [styles.cardDefaultTitleUppercase]: showNoImageTextUppercase,
          })}
        >
          {noImageText}
        </div>
      )}
    </div>
  );
};

export default ImageWrapper;
